// Recipient type keys the backend supports (RECIPIENT_RESOLVERS in reminder_setup/recipient_type/controller.js).
export const RECIPIENT_TYPE_LABEL = {
  SUBJECT_USER: "User (the case is about)",
  ROW_USER: "User from the record",
  ROW_EMAIL: "Email from the record",
  ASSIGNED_ADMIN: "Assigned admin",
  EMPLOYEE_ADMINS: "Employee's admins",
  COMPANY_OWNER: "Company owner",
  ROLE: "Everyone with a role",
  SPECIFIC_USERS: "Specific users",
  STATIC_EMAIL: "Fixed email addresses",
};

// Types that resolve to bare email addresses, so only the Email channel can reach them.
export const EMAIL_ONLY_TYPES = ["ROW_EMAIL", "STATIC_EMAIL"];
